import React from "react";

const SameDayPickup=()=>{
    
    return(<div className="container p-3">
        <div className="container-3 p-4">
        <span style={{fontSize:"20px", fontWeight:500}} >Same day pickup service:</span><br></br>
        <span style={{fontSize:"15px", fontWeight:400}}>In most cases, we can schedule same day pickup of your device(s) from the address you provided online while checking out. Same day pickup services are available in these following cities of the GTA.</span>
                                <ul  style={{fontSize:"14px", fontWeight:400}}>
                                    <li>Ajax</li>
                                    <li>Brampton</li>
                                    <li>Etobicoke</li>
                                    
                                    <li> Markham</li>
                                   
                                    <li>Mississauga</li>
                                    <li>Oshawa</li>
                                    <li>Pickering</li>
                                    <li>Richmond Hill</li>
                                    
                                    <li>Toronto(Including Scarborough, North York, East York, Thorn cliff etc..)</li>
                                    <li>Vaughan</li>
                                    <li>Whitby</li>
                                </ul>

                                <span style={{fontSize:"15px", fontWeight:400}}><strong>Please note:</strong> Once we received your submission our associate will contact your as per his earliest convenience to schedule meeting with you either by email or by phone as per your availability and his other appointments schedule. </span>
                                    <br></br><br></br>
                                <span style={{fontSize:"15px", fontWeight:400}}>If you’re located outside of these cities, Kindly ship your device(s) to us, we offer express shipping for free, which will deliver your device(s) to us in 1-3 business day and we pay immediately upon receiving of your device once we finished wit our process which won’t take longer than 30 min for single device.</span>
        </div>
    </div>)
}
export default SameDayPickup;